module.exports = __webpack_public_path__ + "img/lessontake_resources_rotate.c36d6347.svg";